module.exports = __webpack_public_path__ + "ae539c6197c731a7eb389861d7616e46.svg";